import { CurrencyLocation, DecimalSeparator, RoundingMethod, ThousandsSeparator } from '../../filters/currency/currency-formatter.const';
import { CurrencyOptions } from '../currency.interfaces';

export const EUR: CurrencyOptions = {
  currencyLocation: CurrencyLocation.APPEND,
  currencySpacing: true,
  decimalDigits: 2,
  decimalSeparator: DecimalSeparator.DOT,
  currencySymbol: '€',
  hideDecimalsIfZero: false,
  roundingMethod: RoundingMethod.ROUND,
  thousandsSeparator: ThousandsSeparator.NONE
};
